export default "__VITE_ASSET__DPyzYfZT__"